
import { Component, Prop, Vue } from 'vue-property-decorator';

import UnderlineForm from "@/components/utils/PopulateForms/components/UnderlineForm.vue";
import CheckBox from "@/components/utils/PopulateForms/components/CheckBox.vue";
import { schedule4DataInfoType } from '@/types/Application/CaseManagement/PDF';
import GreyBoxForm from "@/components/utils/PopulateForms/components/GreyBoxForm.vue";

@Component({
    components: {
        UnderlineForm,
        CheckBox,
        GreyBoxForm
    }
})

export default class Schedule4 extends Vue {

    @Prop({ required: true })
    result!: any;

    dataReady = false;
    accessInfo = {} as schedule4DataInfoType;

    mounted() {
        this.dataReady = false;
        this.extractInfo();
        this.dataReady = true;
    }

    public extractInfo() {
        this.accessInfo = this.getAccessToInformation();
    }

    public getAccessToInformation() {
        let accessToInformation = {} as schedule4DataInfoType;

        if (this.result?.requiringAccessToInformationSurvey) {
            const chgSurvey = this.result.requiringAccessToInformationSurvey;
            accessToInformation.officerSearch = chgSurvey.officerSearch
            accessToInformation.orderDetail = chgSurvey.officerSearch == 'y' ? chgSurvey.orderDetail : ''
            accessToInformation.applicationFacts = chgSurvey.officerSearch == 'y' ? chgSurvey.applicationFacts : ''
        }


        return accessToInformation;
    }
}
